module.exports = __webpack_public_path__ + "media/images/lb/741-06a1e661b01f003673cf94838a5d0611.svg";